import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  CalendarDots,
  DotsThree,
  Handshake,
  Images,
  Phone,
  Star,
  Trophy,
} from "@phosphor-icons/react";
const profilesPhone = "https://d1vqw4it8x9uac.cloudfront.net/admin/profiles-phone-1790236892.png";
const profilesPhone1 = "https://d1vqw4it8x9uac.cloudfront.net/admin/profiles-phone-1-1790236892.png";

const listMotion = {
  hidden: { opacity: 0, y: 26 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
      staggerChildren: 0.12,
      delayChildren: 0.08,
    },
  },
};

const itemMotion = {
  hidden: { opacity: 0, y: 22 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

function Feature({ Icon, title, description, accent, iconWeight = "regular" }) {
  return (
    <motion.li className="revamp-profiles-feature" variants={itemMotion}>
      <div className={`revamp-profiles-icon ${accent ? "is-accent" : ""}`} aria-hidden="true">
        <Icon size={22} weight={iconWeight} />
      </div>
      <div className="revamp-profiles-feature-copy">
        <h3 className={accent ? "is-accent" : ""}>{title}</h3>
        <p>{description}</p>
      </div>
    </motion.li>
  );
}

function RevampProfessionalsProfiles() {
  const [active, setActive] = useState("professional");

  const isProfessional = active === "professional";
  // const profilesPhone = isProfessional ? profilesPhone : profilesPhone1;
  const profilesImage = isProfessional ? profilesPhone : profilesPhone1;
  return (
    <section className="revamp-section-shell revamp-profiles-shell" aria-label="Professional profiles">
      <div className="revamp-profiles-eyebrow">Professional Profiles</div>
      <h2 className="revamp-profiles-heading">
        Just one
        <br />
        <span className="revamp-hero-heading-accent">HYNT Profile</span>
      </h2>
      <p className="revamp-profiles-subcopy">
        No more websites, social media links, PDFs, PPTs.
      </p>

      <div className="revamp-profiles-toggle" role="tablist" aria-label="Profile type">
        <button
          type="button"
          className={`revamp-profiles-pill ${isProfessional ? "is-active" : ""}`}
          role="tab"
          aria-selected={isProfessional}
          onClick={() => setActive("professional")}
        >
          Professional
        </button>
        <button
          type="button"
          className={`revamp-profiles-pill ${!isProfessional ? "is-active" : ""}`}
          role="tab"
          aria-selected={!isProfessional}
          onClick={() => setActive("business")}
        >
          Business
        </button>
      </div>

      <div className="revamp-profiles-grid">
        <div className="revamp-profiles-phone-col" aria-hidden="true">
          <div className="revamp-profiles-phone-stage">
            <img className="revamp-profiles-phone" src={profilesImage} alt="" />
            {/* <span className="revamp-profiles-badge is-left">
              <span className="revamp-profiles-badge-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
                  <path
                    d="M12 2 14.7 8.2 21 10.3l-5 3.9 1.8 6.5L12 17.4 6.2 20.7 8 14.2 3 10.3l6.3-2.1L12 2Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              Elite
            </span>
            <span className="revamp-profiles-badge is-right">Verified</span> */}
          </div>
        </div>

        <div className="revamp-profiles-features-col">
          <motion.ul
            className="revamp-profiles-features"
            variants={listMotion}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <Feature
              accent
              Icon={Images}
              iconWeight="fill"
              title="Your Projects"
              description="Showcase your best projects with photos, videos, descriptions and details that help clients understand your expertise."
            />
            <Feature
              Icon={Trophy}
              title="Awards & Recognition"
              description="Upload certifications, awards, publications, events, and achievements that build credibility and trust."
            />
            <Feature
              Icon={Star}
              title="Client Reviews & Testimonials"
              description="Let real client experiences, ratings, and feedback help homeowners choose you with confidence."
            />
            <Feature
              Icon={Handshake}
              title="Services Offered"
              description="Clearly list the services you provide, consultation options, project types, and areas of expertise."
            />
            <Feature
              Icon={CalendarDots}
              iconWeight="fill"
              title="Design Styles & Expertise"
              description="Show your preferred styles, materials, specializations, and the kind of projects you’re known for."
            />
            <Feature
              Icon={Phone}
              title="Contact Details"
              description="Make it easy for clients to connect with you."
            />
            <Feature
              Icon={DotsThree}
              title=" and much more"
              description={`From others details to all documents — build a complete ${
                isProfessional ? "professional" : "business"
              } presence on HYNT.`}
            />
          </motion.ul>
        </div>
      </div>
    </section>
  );
}

export default RevampProfessionalsProfiles;

